import { MobModel } from "types";

import ardinPilotImage from "assets/mob-ardin-pilot.svg";
import ardinShipImage from "assets/mob-ardin-ship.svg";
import crossPilotImage from "assets/mob-cross-pilot.svg";
import crossShipImage from "assets/mob-cross-ship.svg";
import gammaPilotImage from "assets/mob-gamma-pilot.svg";
import gammaShipImage from "assets/mob-gamma-ship.svg";
import ketherPilotImage from "assets/mob-kether-pilot.svg";
import ketherShipImage from "assets/mob-kether-ship.svg";
import lockheedPilotImage from "assets/mob-lockheed-pilot.svg";
import lockheedShipImage from "assets/mob-lockheed-ship.svg";
import sharperPilotImage from "assets/mob-sharper-pilot.svg";
import sharperShipImage from "assets/mob-sharper-ship.svg";

import { BASE_STATS } from "data/baseStats";

const { FIREPOWER, RESILIENCE, SPEED, PRECISION, ENERGY } = BASE_STATS;

// SECTOR TIER 1 - MEDALLION RANGE: 1-20

const BISHOP_HOLLOWLANDS_MOBS: Record<string, MobModel> = {
  ardin: {
    name: "Ardin",
    images: {
      ship: ardinShipImage,
      pilot: ardinPilotImage,
    },
    dialogs: {
      opening:
        "Okay yeah, let's fight. It'll make look good in front of the others when I destroy you.",
      win: "You embarrassed me in front of everybody, I might get demoted ...again.",
      lose: "Woo, I did it! Maybe this will earn me a promotion.",
    },
    position: 60,
    heightPercentage: 30,
    medallions: 1,
    baseStatsModifiers: {
      firepower: 5,
      resilience: 2,
      speed: 4,
      precision: 1,
      energy: 3,
    },
    baseStatsCosts: {
      firepower: 1,
      resilience: 2,
      speed: 2,
      precision: 3,
      energy: 2,
    },
    baseStatsTargets: [FIREPOWER, RESILIENCE, SPEED, PRECISION, ENERGY],
    isBoss: false,
    drops: {
      platinum: "burst_laser",
      gold: "pulse_laser",
      silver: "spark_booster",
      bronze: "zero_core",
    },
    installedUpgrades: {
      weapons: "burst_laser",
      shields: null,
      thrusters: "spark_booster",
      targetingSystem: null,
      reactorCore: "zero_core",
    },
    partPositions: {
      weapons: { x: 45, y: 55 },
      targeting: { x: 63, y: 55 },
      thrusters: { x: 29, y: 49.5 },
    },
    skills: ["shieldBreaker"],
  },
  sharper: {
    name: "Sharper",
    images: {
      ship: sharperShipImage,
      pilot: sharperPilotImage,
    },
    dialogs: {
      opening: "Ugh, you're challenging me to a fight? I'm trying to nap here.",
      win: "Okay, yay, you defeated me. Now go away and let me sleep.",
      lose: "I told you to leave me alone.",
    },
    position: 90,
    heightPercentage: 30,
    medallions: 4,
    baseStatsModifiers: {
      firepower: 2,
      resilience: 4,
      speed: 3,
      precision: 5,
      energy: 1,
    },
    baseStatsCosts: {
      firepower: 2,
      resilience: 2,
      speed: 2,
      precision: 1,
      energy: 3,
    },
    baseStatsTargets: [SPEED, FIREPOWER, PRECISION, RESILIENCE, ENERGY],
    isBoss: false,
    drops: {
      platinum: "sharp_scope",
      gold: "vision_scope",
      silver: "shimmer_shield",
      bronze: "light_thruster",
    },
    installedUpgrades: {
      weapons: null,
      shields: "shimmer_shield",
      thrusters: "light_thruster",
      targetingSystem: "sharp_scope",
      reactorCore: null,
    },
    partPositions: {
      weapons: { x: 68, y: 55.75 },
      targeting: { x: 77, y: 55.75 },
      thrusters: { x: 23.6, y: 49.75 },
    },
    skills: ["pressurePoint"],
  },
  cross: {
    name: "Cross",
    images: {
      ship: crossShipImage,
      pilot: crossPilotImage,
    },
    dialogs: {
      opening: "YEAH LET'S FIGHT LET'S GO RIGHT NOW FIGHT FIGHT FIGHT",
      win: "I DIDN'T EXPECT THAT BUT OKAY",
      lose: "LET'S GO AGAIN",
    },
    position: 120,
    heightPercentage: 30,
    medallions: 7,
    baseStatsModifiers: {
      firepower: 1,
      resilience: 3,
      speed: 2,
      precision: 4,
      energy: 5,
    },
    baseStatsCosts: {
      firepower: 3,
      resilience: 2,
      speed: 2,
      precision: 2,
      energy: 1,
    },
    baseStatsTargets: [ENERGY, SPEED, FIREPOWER, PRECISION, RESILIENCE],
    isBoss: false,
    drops: {
      platinum: "storm_cell",
      gold: "wave_cell",
      silver: "small_scope",
      bronze: "glimmer_shield",
    },
    installedUpgrades: {
      weapons: null,
      shields: "glimmer_shield",
      thrusters: null,
      targetingSystem: "small_scope",
      reactorCore: "storm_cell",
    },
    partPositions: {
      weapons: { x: 67, y: 55.25 },
      targeting: { x: 77, y: 55.25 },
      thrusters: { x: 26.2, y: 49 },
    },
    skills: ["energyBlast"],
  },
  kether: {
    name: "Kether",
    images: {
      ship: ketherShipImage,
      pilot: ketherPilotImage,
    },
    dialogs: {
      opening: "I'm gonna fly circles around you, slowpoke.",
      win: "I'm not that... fast? Oh my god, my whole identity.",
      lose: "I told you, sluggo.",
    },
    position: 150,
    heightPercentage: 30,
    medallions: 11,
    baseStatsModifiers: {
      firepower: 4,
      resilience: 1,
      speed: 5,
      precision: 3,
      energy: 2,
    },
    baseStatsCosts: {
      firepower: 2,
      resilience: 3,
      speed: 1,
      precision: 2,
      energy: 2,
    },
    baseStatsTargets: [ENERGY, PRECISION, SPEED, RESILIENCE, FIREPOWER],
    isBoss: false,
    drops: {
      platinum: "kinetica",
      gold: "flash_rocket",
      silver: "fade_laser",
      bronze: "dark_scope",
    },
    installedUpgrades: {
      weapons: "fade_laser",
      shields: null,
      thrusters: "kinetica",
      targetingSystem: "dark_scope",
      reactorCore: null,
    },
    partPositions: {
      weapons: { x: 56, y: 53.25 },
      targeting: { x: 66, y: 53.25 },
      thrusters: { x: 35.2, y: 49.5 },
    },
    skills: ["rapidFire"],
  },
  gamma: {
    name: "Gamma",
    images: {
      ship: gammaShipImage,
      pilot: gammaPilotImage,
    },
    dialogs: {
      opening:
        "My ship can take a million hits, you sure you want to fight me?",
      win: "Okay fine, my ship can take less than a million hits, apparently.",
      lose: "Come back when you're actually ready to do some real damage.",
    },
    position: 180,
    heightPercentage: 30,
    medallions: 15,
    baseStatsModifiers: {
      firepower: 3,
      resilience: 5,
      speed: 1,
      precision: 2,
      energy: 4,
    },
    baseStatsCosts: {
      firepower: 2,
      resilience: 1,
      speed: 3,
      precision: 2,
      energy: 2,
    },
    baseStatsTargets: [RESILIENCE, FIREPOWER, ENERGY, SPEED, PRECISION],
    isBoss: false,
    drops: {
      platinum: "guardian_shield",
      gold: "protector_shield",
      silver: "quick_core",
      bronze: "glance_laser",
    },
    installedUpgrades: {
      weapons: "glance_laser",
      shields: "guardian_shield",
      thrusters: null,
      targetingSystem: null,
      reactorCore: "quick_core",
    },
    partPositions: {
      weapons: { x: 80, y: 57.75 },
      targeting: { x: 91, y: 57.75 },
      thrusters: { x: 13, y: 48.5 },
    },
    skills: ["emergencyRepairs"],
  },
  lockheed: {
    name: "Lockheed",
    images: {
      ship: lockheedShipImage,
      pilot: lockheedPilotImage,
    },
    dialogs: {
      opening: "No one ever wants to fight me. Sure, why not?",
      win: "That was fun, I haven't felt that much excitement in ages.",
      lose: "I guess that's why nobody challenges me.",
    },
    position: 210,
    heightPercentage: 30,
    medallions: 20,
    baseStatsModifiers: {
      firepower: 4,
      resilience: 3,
      speed: 2,
      precision: 4,
      energy: 2,
    },
    baseStatsCosts: {
      firepower: 1,
      resilience: 2,
      speed: 3,
      precision: 2,
      energy: 2,
    },
    baseStatsTargets: [RESILIENCE, FIREPOWER, PRECISION, ENERGY, SPEED],
    isBoss: false,
    drops: {
      platinum: "firebrand",
      gold: "heatseeker",
      silver: "lock_sight",
      bronze: "ion_barrier",
    },
    installedUpgrades: {
      weapons: "firebrand",
      shields: "ion_barrier",
      thrusters: "spark_booster",
      targetingSystem: "lock_sight",
      reactorCore: "zero_core",
    },
    partPositions: {
      weapons: { x: 52, y: 57.75 },
      targeting: { x: 61.5, y: 57.75 },
      thrusters: { x: 24.2, y: 52.25 },
    },
    skills: ["rapidFire", "emergencyRepairs"],
  },
};

export default BISHOP_HOLLOWLANDS_MOBS;
